import { CustomerDto } from "./DTO/customer-dto";

export class CustomerVenueStatisticItem {
	pk: string; //:venueKey_statisticTypeEnum
	sk: string; //customerKey
	statisticValue: number;
	created: string;
	previousCustomerKey: string;

	customer: CustomerDto;

	public constructor(init?: Partial<CustomerVenueStatisticItem>) {
		Object.assign(this, init);
	}
}
